import React from "react";
import {Link} from 'react-router-dom';
import CommonUtil from "../../../utils/CommonUtil";
import PageContainer from "../../layout/PageContainer";
import LayoutAside from "../LayoutAside";
import Button from "../../../components/buttons";
import UI from "components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../domain/main/com/file/mapng/TbComFileMapngDetail";

export default ContentsContainer;

function ContentsContainer() {

    const onClickUploadHandler = () => {
        CommonUtil.simpleExcelUpload("sampleFileUpload", {
            OPTION1: "OPTION1",
            OPTION2: "OPTION2"
        })
            .then(value => console.log(value))
            .catch(value => console.log(value));
    }

    const fileValue = new TbComFile();
    fileValue.tbComFileMapngDetailList = [];
    const detail = new TbComFileMapngDetail();
    detail.setDwldId("5ACE4DB2-CF0E-4D8F-8500-B2EE42E1074B");
    detail.setFileDetailId("76A9RUUF1CBC784650");
    detail.setFilePolicy("raonk");
    detail.setFileRpstr("raonk");
    detail.setStrePath("/2024/03");
    detail.setStreFileNm("59f1209196071fa798a23596dbef3337.pdf");
    detail.setOrginlFileNm("지역사회 및 중소기업 상생협력 제고를 위한 인센티브 지원사업(포항지역)_변경심사신청서_날인본.pdf");
    detail.setFileExtsn("pdf");
    detail.setFileSize(756662);
    fileValue.tbComFileMapngDetailList.push(detail);

    return (
        <PageContainer session={false}>
            <LayoutAside/>
            <div className='fww-con'>
                <ul className="fww-brd">
                    <li><Link to="/example">홈</Link></li>
                    <li><Link to="#">IBSheet</Link></li>
                </ul>
                <h1 className="tx tx-hd2">Simple Excel File Upload</h1>
                <div className="fww-main">
                    <div className="tb-top">
                        <Button color="pri" size="md" onClick={onClickUploadHandler}>업로드</Button>
                    </div>
                </div>

                <h1 className="tx tx-hd2">Simple File Download</h1>
                <h2 className="tx tx-hd3">Simple mode</h2>
                <div className="tb-view-file">
                    <UI.FileDownloadSimpleMode value={fileValue} viewMode={"simple"}/>
                </div>
                <h2 className="tx tx-hd3">Table mode</h2>
                <div className="tb-view-file">
                    <UI.FileDownloadSimpleMode value={fileValue} viewMode={"table"}/>
                </div>
                <h2 className="tx tx-hd3">Table mode & rowNumber=true</h2>
                <div className="tb-view-file">
                    <UI.FileDownloadSimpleMode value={fileValue} viewMode={"table"} rowNumber={true}/>
                </div>
            </div>
        </PageContainer>
    );
}